import React from 'react';
import clsx from 'clsx';

import { ContentBlock } from './wrappers';

interface IContentBlock {
  children: React.ReactNode;
  maxWidth?: string;
  alignCenter?: boolean;
}

export default ({ children, alignCenter, maxWidth }: IContentBlock) => (
  <ContentBlock className={clsx(alignCenter && 'align-center')} maxWidth={maxWidth}>
    {children}
  </ContentBlock>
);
